import { apiService } from "./core/api.service";


export const resetPasswordApi = {
  // Auth - Password reset
  async forgotPassword(email: string): Promise<{ message: string }> {
    return apiService.request<{ message: string }>("/auth/forgot-password", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  },

  async resetPassword(
    token: string,
    password: string
  ): Promise<{ message: string }> {
    // si tu back lo recibe por query:
    return apiService.request<{ message: string }>(`/auth/reset-password`, {
      method: "POST",
      body: JSON.stringify({ token, newPassword: password }),
    });
  },
};
